
import { defineComponent } from "vue";

export default defineComponent({
  name: "ApprovalResultDefault",
  props: {
    message: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    return {
      ...props
    };
  }
});
